import React, { useState } from 'react';

import { Button, Select } from 'common-src/components/base';
import { apiRequest, getRestErrorMessage, HttpMethods } from 'common-src/features/rest';

import useAlert from 'src/hooks/useAlert';

import styles from './Reports.module.scss';

const TARGET_OPTIONS = [
  { label: 'Leads', value: 'leads' },
  { label: 'Closed Patients', value: 'patients' },
];

const JOB_TYPE = {
  CHECK: 'check',
  REPORT: 'report',
};

const JOB_CONFIG = {
  [JOB_TYPE.CHECK]: {
    endpointSuffix: 'eligibilityRequest',
    buttonText: 'Request Eligibility Check',
    successMessage: 'Eligibility check requested',
  },
  [JOB_TYPE.REPORT]: {
    endpointSuffix: 'eligibilityReport',
    buttonText: 'Request Eligibility Report',
    successMessage: 'Eligibility report requested',
  },
};

const Reports = () => {
  const [target, setTarget] = useState(TARGET_OPTIONS[0]);
  const [loadingType, setLoadingType] = useState(null);
  const { showAlert, AlertType } = useAlert();
  const handleSubmit = (type) => {
    const config = JOB_CONFIG[type];
    if (!config) return;

    setLoadingType(type);

    const endpoint = `jobRequests/${config.endpointSuffix}`;

    apiRequest({
      endpoint,
      method: HttpMethods.Post,
      body: { target: target.value },
    }).then(async (res) => {
      if (!res.ok) {
        const err = await res.json();
        const errMsg = getRestErrorMessage(err) || '';
        showAlert(AlertType.Error, '', errMsg);
        setLoadingType(null);
        return;
      }

      showAlert(AlertType.Success, '', config.successMessage);
      setLoadingType(null);
    });
  };

  return (
    <section className={styles.container}>
      <h2 className={styles.sectionTitle}>Eligibility Jobs</h2>
      <div className={styles.grid}>
        <p className={styles.note}>Pick a target for eligibility request</p>
        <Select
          id="eligibility-target"
          label="Target"
          options={TARGET_OPTIONS}
          onChange={(option) => setTarget(option)}
          value={target}
        />
        <div className={styles.buttonRow}>
          <Button
            id="eligibility-request"
            text="Request Eligibility Check"
            onClick={() => handleSubmit(JOB_TYPE.CHECK)}
            isLoading={loadingType === JOB_TYPE.CHECK}
          />
          <p className={styles.note}>
            Note: Run Request Eligibility Report at least 2 hours after running Request Eligibility
            Check
          </p>
          <Button
            id="eligibility-report"
            text="Request Eligibility Report"
            onClick={() => handleSubmit(JOB_TYPE.REPORT)}
            isLoading={loadingType === JOB_TYPE.REPORT}
          />
        </div>
      </div>
    </section>
  );
};

export default Reports;
